import { useTranslation } from 'react-i18next';
import ArticleCard from '@/components/base/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedSection() {
  const { t } = useTranslation();
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
            Editor&apos;s Pick
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            {t('section.featured')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}